import { FunctionComponent } from 'react';
import { useUser } from '@/modules/users/contexts/UserContext';
import { UserType } from '@/modules/users/api/users/users.contracts';
import { ApplicationLayout } from './ApplicationLayout';
import { GuestApplicationLayout } from './GuestApplicationLayout';

export const ConditionalApplicationLayout: FunctionComponent = () => {
  const { user } = useUser();

  // Show guest layout for guest users, regular layout for others
  if (user?.type === UserType.GUEST) {
    return <GuestApplicationLayout />;
  }

  return <ApplicationLayout />;
};
